<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before:always;"></div>
<h1 class="P_Heading_1__And__Page_Break" id="auto_bookmark_table_of_contents_1"><span>Remerciements</span></h1>
<p class="P_Normal"> </p>
<p class="P_Normal"> </p>
<p class="P_Normal">Muchas gracias à Manuel Elizondo de m’avoir donné des aperçus de la culture portoricaine et de la vie dans Humboldt Park ; à Lynda Fitzgerald, l’extraordinaire lectrice de mes versions beta ; et à J.P. Barnaby, le meilleur critique du monde. Et à Vic et Lin, qui n’ont rien lâché jusqu’à ce que je monte sur une selle.</p>
<p class="P_Normal">No podria haberlo hecho sin su ayuda.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?61d49e14